"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RadioButton_1 = require("./RadioButton");
exports.default = RadioButton_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/RadioGroup/components/RadioButton/index.js
// module id = 824
// module chunks = 8